import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Panel from './pages/Panel';
import Sensores from './pages/Sensores';
import RutaProtegida from './components/RutaProtegida';
import LecturasTiempoReal from './pages/LecturasTiempoReal';
import HistorialLecturas from './pages/HistorialLecturas';
import Configuraciones from './pages/Configuraciones';
import Alarmas from './pages/Alarmas';
import LecturasHistoricas from './pages/LecturasHistoricas'; // Asegúrate que la ruta coincida



function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/panel"
          element={
            <RutaProtegida>
              <Panel />
            </RutaProtegida>
          }
        />
        <Route
          path="/configuraciones"
          element={
            <RutaProtegida>
              <Configuraciones />
            </RutaProtegida>
          }
        />
        <Route
          path="/alarmas"
          element={
            <RutaProtegida>
              <Alarmas />
            </RutaProtegida>
          }
        />

        <Route
          path="/sensores"
          element={
            <RutaProtegida>
              <Sensores />
            </RutaProtegida>
          }
          
        />
        <Route
          path="/tiempo-real"
          element={
            <RutaProtegida>
              <LecturasTiempoReal />
            </RutaProtegida>
          }
        />
        <Route
          path="/historial-lecturas"
          element={
            <RutaProtegida>
              <HistorialLecturas />
            </RutaProtegida>
          }
        />
        <Route
          path="/historial"
          element={
            <RutaProtegida>
              <HistorialLecturas />
            </RutaProtegida>
          }
        />
        <Route
          path="/lecturas-historicas"
          element={
            <RutaProtegida>
              <LecturasHistoricas />
            </RutaProtegida>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
